import styles from "./Production.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import {
  DispatchReloadIcon,
  CreateVoucherIcon,
} from "../../components/icons/Icon";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import Button from "../../components/updatedComponents/Dealers/Button";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Pagination2 from "../../components/updatedComponents/FormComponents/Pagination2";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilter,
  setPagination,
  setUi,
} from "../../store/slices/production/ProductionSlice";
import { daysData, yearData } from "../../constants/constants";

import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { TemplateNotFound } from "../../components/icons/Icon2";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import { formatDateTime, LastActionCell } from "../../Utils/Utils";
import ThreeDotMenu from "../../components/updatedComponents/Production/ThreeDotMenu";
import { StatusBadge } from "../../components/updatedComponents/Production/StatusBadge";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import QueueEditModal from "../../components/updatedComponents/Production/QueueEditModal";
import { ProgressBar } from "../../components/updatedComponents/Production/ProgressBar";
import {
  productionTypeData,
  TAB_COLUMNS,
  TAB_GRIDS,
} from "../../components/updatedComponents/Production/utils";
import UpdateProductionDrawer from "../../components/updatedComponents/Production/UpdateProductionDrawer";
import MobileProductionCard from "./MobileProductionCard";
import ProductionFilters from "../../components/updatedComponents/Production/ProductionFilters";
import fetchData from "../../APIsControll/apiControll";
import useTableHeight from "../../components/updatedComponents/Production/Usetableheight";
import useDebounce from "../../components/updatedComponents/Production/Usedebounce";
import { socket, SocketConnected } from "../../Socket/socket";
import PriorityEditModal from "../../components/updatedComponents/Production/PriorityEditModal";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import CancelReasonModal from "../../components/updatedComponents/Production/CancelReasonModal";
import { CryptoDecrypt } from "../../Utils/TextUtils";
import ReleaseLineModal from "../../components/updatedComponents/Production/ReleaseLineModal";

// ─── helpers to turn the raw API voucher/item payload into table rows ─────────

// "Order Wise" -> one row per voucher
const mapOrderWise = (vouchers = []) =>
  vouchers.map((v, i) => ({
    id: v.voucherId,
    orderId: v.voucherId,
    voucherNo: v.voucherId,
    createdAt: v.createdAt || v.voucherDate,
    updatedAt: v.lastAction,
    warehouse: v.warehousename,
    warehouseId: v.warehouseId,
    totalItems: v.totalItems,
    pendingItems: v.pendingItems,
    totalQty: v.totalQty,
    pendingQty: v.pendingQty,
    requiredQty: v.totalQty,
    producedQty: Math.max((v.totalQty || 0) - (v.pendingQty || 0), 0),
    status: v.status,
    priority: v.priority,
    customer: v.name || v.storeName,
    dealerId: v.dealerId,
    // queueNo: v.voucherQueue ?? i + 1,
    queueNo: v.voucherQueue,
    items: v.items || [],
    itemsHistory: v.itemsHistory || [],
  }));

// "Item Wise" -> one row per item, flattened out of every voucher
const mapItemWise = (vouchers = []) => {
  const rows = [];
  vouchers.forEach((v) => {
    (v.items || []).forEach((item) => {
      rows.push({
        id: `${v.voucherId}-${item.index}`,
        orderId: v.voucherId,
        voucherNo: v.voucherId,
        createdAt: v.createdAt || v.voucherDate,
        updatedAt: v.lastAction,
        warehouse: v.warehousename,
        warehouseId: v.warehouseId,
        itemCode: item.itemNo,
        collection: item.collection_name,
        customer: v.name || v.storeName,
        priority: v.priority,
        requiredQty: item.qty,
        totalQty: item.qty,
        producedQty: item.producedQty || 0,
        pendingQty: item.pendingQty ?? item.qty,
        status: v.status,
        machine: item.pLName || "",
        productionLine: item.productionLine || "",
        pLId: item.productionLine || "",
        thumbnail: item.thumbnail,
        queueNo: item.itemQueue,
        voucherQueue: v.voucherQueue,
        itemsHistory: v.itemsHistory || [],
        itemId: item.itemId || "",
        itemStatus: item.status,
      });
    });
  });
  // return rows.map((r, i) => ({ ...r, queueNo: r.queueNo ?? i + 1 }));
  return rows.map((r, i) => ({ ...r, queueNo: r.queueNo }));
};

// "Production Line Wise" -> one row per item, keyed around the machine/line
const mapProductionLineWise = (vouchers = []) => {
  const rows = [];
  vouchers.forEach((v) => {
    (v.items || []).forEach((item) => {
      rows.push({
        id: `${v.voucherId}-${item.index}`,
        orderId: v.voucherId,
        voucherNo: v.voucherId,
        createdAt: v.createdAt || v.voucherDate,
        updatedAt: v.lastAction,
        warehouse: v.warehousename,
        warehouseId: v.warehouseId,
        itemCode: item.itemNo,
        collection: item.collection_name,
        customer: v.name || v.storeName,
        priority: v.priority,
        machine: item.pLName || "",
        productionLine: item.productionLine,
        pLId: item.productionLine || "",
        requiredQty: item.qty,
        totalQty: item.qty,
        producedQty: item.producedQty || 0,
        pendingQty: item.pendingQty ?? item.qty,
        status: v.status,
        queueNo: item.itemQueue,
        voucherQueue: v.voucherQueue,
        itemsHistory: v.itemsHistory || [],
        itemId: item.itemId || "",
        itemStatus: item.status,
      });
    });
  });
  // return rows.map((r, i) => ({ ...r, queueNo: r.queueNo ?? i + 1 }));
  return rows.map((r, i) => ({ ...r, queueNo: r.queueNo }));
};

const TAB_MAPPERS = {
  "Order Wise": mapOrderWise,
  "Item Wise": mapItemWise,
  "Production Line Wise": mapProductionLineWise,
};

const ITEM_LEVEL_TABS = ["Item Wise", "Production Line Wise"];
const ITEM_LEVEL_FETCH_LIMIT = 300; // vouchers pulled per fetch for item-level tabs

const SkeletonRow = ({ gridTemplate, columns, mode }) => (
  <li
    className={`${styles.skeletonRow} ${mode ? styles.skeletonRowDark : ""}`}
    style={{ gridTemplateColumns: gridTemplate }}
  >
    <div
      className={`${styles.skeletonBlock} ${mode ? styles.skeletonBlockDark : ""}`}
      style={{ width: 24 }}
    />
    {columns.map((col) => (
      <div
        key={col.key}
        className={`${styles.skeletonBlock} ${mode ? styles.skeletonBlockDark : ""}`}
      />
    ))}
  </li>
);

const TableSkeleton = ({ gridTemplate, columns, rows, mode }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <SkeletonRow
        key={i}
        gridTemplate={gridTemplate}
        columns={columns}
        mode={mode}
      />
    ))}
  </>
);
// ─── Main Production Component ────────────────────────────────────────────────
const Production = () => {
  const { mode, designations, managerId, designation } = useAuth();
  const { filter, pagination } = useSelector((r) => r.production);
  const production = useDispatch();
  const navigate = useNavigate();
  const { show } = useToast();

  const productionSaveLock = useRef(false);

  const tableRef = useRef(null);
  const limit = useTableHeight(tableRef);

  const [managerAuth, setManagerAuth] = useState({});

  useEffect(() => {
    const encrypted = localStorage.getItem("productionManagerAuth");

    if (encrypted) {
      try {
        // const bytes = CryptoJS.AES.decrypt(encrypted, "secret key");
        const decrypted = JSON.parse(CryptoDecrypt(encrypted));

        setManagerAuth(decrypted);
      } catch (error) {
        console.error("Failed to decrypt managerAuth:", error);
      }
    }
  }, []);

  // ─── recompute queueNo ────────────────────────────────────────────────────
  const requeue = (arr) => arr.map((item, i) => ({ ...item, queueNo: i + 1 }));
  const debouncedKeyword = useDebounce(filter.keyword, 700);

  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [productionQty, setProductionQty] = useState("");
  const [machine, setMachine] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  const [machines, setMachines] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [reFetch, setReFetch] = useState(false);

  const [queueEditItem, setQueueEditItem] = useState(null);
  const [queueloader, setQueueLoader] = useState(false);

  const [maxQueue, setMaxQueue] = useState("");
  const [queueMaxLoader, setQueueMaxLoader] = useState(false);

  const [cancelItem, setCancelItem] = useState(null);
  const [cancelLoader, setCancelLoader] = useState(false);

  const [releaseLoader, setReleaseLoader] = useState(false);
  const [releaseLineItem, setReleaseLineItem] = useState(null);

  const [priorityEditItem, setPriorityEditItem] = useState(null);
  const [priorityLoader, setPriorityLoader] = useState(false);
  const [productionLoader, setProductionLoader] = useState(false);

  const [productionTableData, setProductionTableData] = useState({
    "Order Wise": [],
    "Item Wise": [],
    "Production Line Wise": [],
  });

  const [statusData, setStatusData] = useState({
    "Order Wise": [],
    "Item Wise": [],
    "Production Line Wise": [],
  });

  const [mobileProdItem, setMobileProdItem] = useState(null);

  const activeType = productionTypeData.includes(filter.voucherTab)
    ? filter.voucherTab
    : "Order Wise";

  const isItemLevelTab = ITEM_LEVEL_TABS.includes(activeType);

  const currentData = productionTableData[activeType] || [];
  const columns = TAB_COLUMNS[activeType];
  const gridTemplate = TAB_GRIDS[activeType];

  const STATIC_STATUS_LIST = [
    { status: "All", label: "All" },
    { status: "New Voucher", label: "New Voucher" },
    { status: "In Production", label: "In Production" },
    { status: "Ready For Dispatch", label: "Ready For Dispatch" },
    { status: "Dispatched", label: "Dispatched" },
    { status: "Cancelled", label: "Cancelled" },
  ];

  const statusCards = useMemo(() => {
    const apiCards = statusData[activeType] || [];
    const apiMap = new Map(apiCards.map((c) => [c.status, c]));

    return STATIC_STATUS_LIST.map((cfg) => {
      const match = apiMap.get(cfg.status);
      return {
        status: cfg.status,
        label: cfg.label,
        count: match?.count || 0,
        allCount: match?.prevCount || 0,
        amount: match?.amount || 0,
      };
    });
  }, [statusData, activeType]);

  // ---------------- Working Fine -----------------------------

  // const filteredData = useMemo(() => {
  //   let result = [...currentData];
  //   if (filter.keyword) {
  //     const kw = filter.keyword.toLowerCase();
  //     result = result.filter(
  //       (item) =>
  //         (item.itemCode && item.itemCode.toLowerCase().includes(kw)) ||
  //         (item.orderId && String(item.orderId).toLowerCase().includes(kw)) ||
  //         (item.voucherNo && item.voucherNo.toLowerCase().includes(kw)) ||
  //         (item.customer && item.customer.toLowerCase().includes(kw)) ||
  //         (item.productionLine &&
  //           item.productionLine.toLowerCase().includes(kw)) ||
  //         (item.collection && item.collection.toLowerCase().includes(kw)),
  //     );
  //   }
  //   if (filter.selectedFilter && filter.selectedFilter !== "All") {
  //     result = result.filter((item) => item.status === filter.selectedFilter);
  //   }
  //   if (activeType === "Production Line Wise" && selectedMachine) {
  //     result = result.filter((item) => item.productionLine === selectedMachine);
  //   }
  //   return result;
  // }, [
  //   filter.keyword,
  //   filter.selectedFilter,
  //   currentData,
  //   activeType,
  //   selectedMachine,
  // ]);

  // Item-level tabs (Item Wise / Production Line Wise) paginate the
  // *flattened rows* on the client, because the API's `limit` counts
  // vouchers, not items — one voucher can contain many items, so
  // "8 vouchers" could mean anywhere from 8 to 100+ rows. Order Wise is
  // 1 row per voucher, so the API's own paging already matches exactly.
  // --------------------------------------------------------------------------------

  // ----------------- for Change like this type show item Wise and Production Line Wise  ----------------------
  // 1/1 Pending item.status
  //  1 Completed item.status not item queue come
  // 1/2 Pending item.status
  //

  // create it like this when not itemQueue come then shift in last of this queueNo
  //  1/1 Pending item.status
  //  1/2 Pending item.status
  //  1 Completed item.status not item queue come

  const filteredData = useMemo(() => {
    let result = [...currentData];

    if (filter.keyword) {
      const kw = filter.keyword.toLowerCase();

      result = result.filter(
        (item) =>
          (item.itemCode && item.itemCode.toLowerCase().includes(kw)) ||
          (item.orderId && String(item.orderId).toLowerCase().includes(kw)) ||
          (item.voucherNo && item.voucherNo.toLowerCase().includes(kw)) ||
          (item.customer && item.customer.toLowerCase().includes(kw)) ||
          (item.productionLine &&
            item.productionLine.toLowerCase().includes(kw)) ||
          (item.collection && item.collection.toLowerCase().includes(kw)),
      );
    }

    if (filter.selectedFilter && filter.selectedFilter !== "All") {
      result = result.filter((item) => item.status === filter.selectedFilter);
    }

    if (activeType === "Production Line Wise" && selectedMachine) {
      result = result.filter((item) => item.productionLine === selectedMachine);
    }

    // Item Wise / Production Line Wise
    // Rows without itemQueue go to the bottom
    // Item Wise / Production Line Wise
    if (activeType === "Item Wise" || activeType === "Production Line Wise") {
      result.sort((a, b) => {
        // Keep different vouchers in their existing API order
        if (a.orderId !== b.orderId) {
          return 0;
        }

        const aHasQueue =
          a.queueNo !== undefined && a.queueNo !== null && a.queueNo !== "";

        const bHasQueue =
          b.queueNo !== undefined && b.queueNo !== null && b.queueNo !== "";

        // Both have item queue
        if (aHasQueue && bHasQueue) {
          return Number(a.queueNo) - Number(b.queueNo);
        }

        // Missing item queue goes AFTER queued items
        if (aHasQueue && !bHasQueue) {
          return -1;
        }

        if (!aHasQueue && bHasQueue) {
          return 1;
        }

        return 0;
      });
    }

    return result;
  }, [
    filter.keyword,
    filter.selectedFilter,
    currentData,
    activeType,
    selectedMachine,
  ]);
  // ----------------------------------------------------------------

  const pagedData = useMemo(() => {
    if (!isItemLevelTab) return filteredData;
    const start = (pagination.page - 1) * limit;
    return filteredData.slice(start, start + limit);
  }, [filteredData, isItemLevelTab, pagination.page, limit]);

  useEffect(() => {
    if (!isItemLevelTab) return;
    const totalPages = Math.max(1, Math.ceil(filteredData.length / limit));
    if (pagination.pages !== totalPages) {
      production(setPagination({ pages: totalPages }));
    }
    if (pagination.page > totalPages) {
      production(setPagination({ page: 1 }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isItemLevelTab, filteredData.length, limit]);

  useEffect(() => {
    production(setPagination({ page: 1 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedKeyword, filter.selectedFilter, activeType]);

  // --------------------------------- Socket start -------------------------------

  const getAllProductionData = useCallback(async () => {
    // Period selected hai but dates nahi hain
    // => API call nahi honi chahiye
    if (
      filter.orderdDaysTab === "period" &&
      (!filter.orderStartDate || !filter.orderEndDate)
    ) {
      return;
    }

    const sortKey =
      activeType === "Production Line Wise" ? "Production Line Wise" : "";

    const apiLimit = isItemLevelTab ? ITEM_LEVEL_FETCH_LIMIT : limit;

    const apiPage = isItemLevelTab ? 1 : pagination.page;

    const apiData = {
      managerId,
      warehouseId: filter.selectedWarehouseId || "",
      sortKey,
      pLId: activeType === "Production Line Wise" ? selectedMachine || "" : "",
      day: filter.orderdDaysTab === "period" ? "" : filter.orderdDaysTab,
      startDate: filter.orderStartDate || "",
      endDate: filter.orderEndDate || "",
      voucherStatus:
        filter.selectedFilter && filter.selectedFilter !== "All"
          ? filter.selectedFilter
          : "",
      keyword: filter.keyword || "",
    };

    setLoading(true);

    try {
      const result = await fetchData(
        `production/allProductionVoucher?page=${apiPage}&limit=${apiLimit}`,
        apiData,
      );

      if (result?.status === "success") {
        const rawVouchers = result.data || [];

        const mapper = TAB_MAPPERS[activeType] || mapOrderWise;

        const rows = mapper(rawVouchers);

        setProductionTableData((prev) => ({
          ...prev,
          [activeType]: rows,
        }));

        setStatusData((prev) => ({
          ...prev,
          [activeType]: result.vouchers || [],
        }));

        if (result.warehouses) {
          setWarehouses(
            result.warehouses.map((w) => ({
              label: w.warehousename,
              value: w.warehouseId,
            })),
          );
        }

        if (result.productionLines) {
          setMachines(
            result.productionLines.map((p) => ({
              label: p.name,
              value: p.pLId,
            })),
          );
        }

        if (!isItemLevelTab) {
          production(
            setPagination({
              pages: result.pages || 1,
            }),
          );
        }
      }
    } catch (error) {
      console.error(error);
      show("Failed to load production data.");
    } finally {
      setLoading(false);
    }
  }, [
    managerId,
    activeType,
    isItemLevelTab,
    selectedMachine,
    filter.selectedWarehouseId,
    filter.orderdDaysTab,
    filter.orderStartDate,
    filter.orderEndDate,
    filter.selectedFilter,
    filter.keyword,
    pagination.page,
    limit,
  ]);

  useEffect(() => {
    // Period + dates missing => don't call API
    if (
      filter.orderdDaysTab === "period" &&
      (!filter.orderStartDate || !filter.orderEndDate)
    ) {
      return;
    }

    getAllProductionData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    managerId,
    activeType,
    selectedMachine,
    filter.selectedWarehouseId,
    filter.orderdDaysTab,
    filter.orderStartDate,
    filter.orderEndDate,
    filter.selectedFilter,
    debouncedKeyword,
    pagination.page,
    limit,
    reFetch,
  ]);

  // --------------------------------- Socket start ----------------------------------

  useEffect(() => {
    if (!managerId || !designation) return;

    const storedWarehouse = JSON.parse(
      localStorage.getItem("warehouse") || "[]",
    );

    const socketData = {
      socketUserId: `${managerId}`,
      role: designation,
      warehouseNames: storedWarehouse,
    };

    SocketConnected(socketData);

    const isSuperAdminUser = designations?.includes("superadmin");

    const handleAllProductionData = (payload) => {
      // console.log("payload---->", payload);

      const voucherData = payload?.allProductionVoucher?.data || [];
      const statusCounts = payload?.allProductionVoucher?.vouchers || [];

      if (!voucherData.length) return;

      // ── permission filter ──────────────────────────────────────────────
      let relevantVouchers = voucherData;

      if (!isSuperAdminUser) {
        // storedWarehouse may be an array of names or objects, so check both
        const allowedWarehouses = storedWarehouse.map((w) =>
          typeof w === "string" ? w : w.warehousename || w.warehouseId,
        );

        relevantVouchers = voucherData.filter(
          (v) =>
            allowedWarehouses.includes(v.warehousename) ||
            allowedWarehouses.includes(v.warehouseId),
        );
      }

      if (!relevantVouchers.length) return;

      // ── merge (upsert) into every tab's table data ─────────────────────
      // setProductionTableData((prev) => {
      //   const updated = { ...prev };

      //   Object.entries(TAB_MAPPERS).forEach(([tabKey, mapper]) => {
      //     const newRows = mapper(relevantVouchers);
      //     const existing = [...(prev[tabKey] || [])];

      //     newRows.forEach((row) => {
      //       const idx = existing.findIndex((r) => r.id === row.id);
      //       if (idx !== -1) {
      //         // update in place, keep its existing queue position
      //         existing[idx] = {
      //           ...existing[idx],
      //           ...row,
      //           queueNo: existing[idx].queueNo,
      //         };
      //       } else {
      //         // new voucher/item -> put at the top
      //         existing.unshift(row);
      //       }
      //     });

      //     updated[tabKey] = requeue(existing);
      //   });

      //   return updated;
      // });

      setProductionTableData((prev) => {
        const updated = { ...prev };

        Object.entries(TAB_MAPPERS).forEach(([tabKey, mapper]) => {
          const newRows = mapper(relevantVouchers);
          const existing = [...(prev[tabKey] || [])];
          const rowsToAddOnTop = [];

          newRows.forEach((row) => {
            const idx = existing.findIndex((r) => r.id === row.id);
            if (idx !== -1) {
              // update in place, keep position and queue number
              existing[idx] = {
                ...existing[idx],
                ...row,
                queueNo: row.queueNo ?? existing[idx].queueNo,
              };
            } else {
              rowsToAddOnTop.push(row); // new voucher keeps its backend queueNo (e.g. 19)
            }
          });

          // new vouchers go to the top, no sort, no requeue
          updated[tabKey] = [...rowsToAddOnTop, ...existing];
        });

        return updated;
      });

      // ── refresh status card counts ──────────────────────────────────────
      if (statusCounts.length) {
        setStatusData((prev) => {
          const updated = { ...prev };
          Object.keys(TAB_MAPPERS).forEach((tabKey) => {
            updated[tabKey] = statusCounts;
          });
          return updated;
        });
      }
    };

    socket.on("allProduction", handleAllProductionData);

    return () => {
      socket.off("allProduction", handleAllProductionData);
    };
  }, [managerId, designation, designations]);

  // --------------------------------- Socket end ----------------------------------

  const handleQueueUpdate = async (v, n, itemId) => {
    // console.log("Queue Update:", v, n);
    // console.log("Active Type:", activeType);

    let endpoint;
    let apiData;

    switch (activeType) {
      case "Order Wise":
        endpoint = "production/updateVoucherQueue";

        apiData = {
          managerId,
          voucherId: v,
          newQueue: n,
        };
        break;

      case "Item Wise":
        endpoint = "production/updateItemQueue";

        apiData = {
          managerId,
          voucherId: v,
          itemId: itemId,
          newItemQueue: n,
        };
        break;

      case "Production Line Wise":
        endpoint = "production/updateItemQueue";

        apiData = {
          managerId,
          voucherId: v,
          itemId: itemId,
          newItemQueue: n,
        };
        break;

      default:
        show("Invalid production type.", "error");
        return;
    }

    try {
      setQueueLoader(true);

      const result = await fetchData(endpoint, apiData);

      // console.log("Queue update result:", result);

      if (result?.status === "success") {
        show(result?.msg || "Queue updated successfully.", "success");

        setQueueEditItem(null);
        setReFetch((prev) => !prev);
      } else {
        show(result?.msg || "Failed to update queue.", "error");
      }
    } catch (error) {
      console.error("Queue update error:", error);

      show("Failed to update queue.", "error");
    } finally {
      setQueueLoader(false);
    }
  };

  // ── Handlers ─────────────────────────────────────────────────────────────
  const handleDayChange = (label) => {
    const selectedFilter = daysData.find((item) => item.label === label);
    const newDayTab = selectedFilter?.value || "today";
    production(setFilter({ orderdDaysTab: newDayTab }));
    if (newDayTab !== "period") {
      // -------------------------------------
      // setStatusData([]);
      setProductionTableData([]);
      // -------------------------------------
      production(setPagination({ pages: [] }));
      production(setFilter({ orderStartDate: "" }));
      production(setFilter({ orderEndDate: "" }));
    }
  };

  const handleVoucherChange = (v) => {
    production(setFilter({ voucherTab: v, selectedFilter: "All" }));
    production(setPagination({ page: 1 }));
    setSelectedMachine("");
  };

  const resetAllStates = () => {
    production(setPagination({ page: 1, pages: 1 }));
    production(
      setFilter({
        selectedWarehouseId: "",
        selectedManagerID: "",
        orderdDaysTab: "today",
        orderStartDate: "",
        orderEndDate: "",
        keyword: "",
        selectedFilter: "All",
        fromWarehouse: "",
        toWarehouse: "",
        meTab: "All",
        orderType: "All",
      }),
    );
    production(setUi({ isSearchBarOpen: false }));
    setSelectedMachine("");
    setLoading(false);
    setReFetch((prev) => !prev);
  };

  const isSuperAdmin = designations.includes("superadmin");

  const openUpdateModal = (item) => {
    // console.log("item.pLId:", item.pLId, typeof item.pLId);
    setSelectedItem(item);
    setProductionQty("");
    setMachine(item.pLId || "");
    setStatus(item.status || "In Production");
    setIsUpdateModalOpen(true);
  };

  const addQty = (qty) => {
    setProductionQty((prev) => (Number(prev) || 0) + qty);
  };

  const completeProduction = () => {
    if (!selectedItem) return;
    setProductionQty(selectedItem.pendingQty);
    setStatus("Ready For Dispatch");
  };
  const handleSaveProduction = async () => {
    // Prevent duplicate API calls
    if (productionSaveLock.current) return;
    const qty = Number(productionQty);

    // if (!qty || qty <= 0) {
    //   show("Please enter a valid production quantity.");
    //   return;
    // }

    let endpoint;
    let apiData;

    switch (activeType) {
      case "Order Wise":
        endpoint = "production/updateVoucherProduction";

        apiData = {
          managerId,
          voucherId: selectedItem.orderId,
          productionQty: qty,
        };
        break;

      case "Item Wise":
        endpoint = "production/updateItemWiseProduction";

        apiData = {
          managerId,
          voucherId: selectedItem.orderId,
          itemId: selectedItem.itemId,
          producedQty: qty,
          productionLine: machine,
        };
        break;

      case "Production Line Wise":
        endpoint = "production/updateItemWiseProduction";

        apiData = {
          managerId,
          voucherId: selectedItem.orderId,
          itemId: selectedItem.itemId,
          producedQty: qty,
          productionLine: machine,
        };
        break;

      default:
        show("Invalid production type.");
        return;
    }

    // Lock immediately, before starting the request
    productionSaveLock.current = true;

    try {
      setProductionLoader(true);
      // console.log("endpoint", endpoint, apiData);

      const result = await fetchData(endpoint, apiData);

      if (result?.status === "success") {
        show(result?.msg || "Production updated successfully.", "success");

        setIsUpdateModalOpen(false);
        setReFetch((prev) => !prev);
      } else {
        show(result?.msg || "Failed to update production.", "error");
      }
    } catch (error) {
      console.error("Production save error:", error);

      show("Failed to update production.", "error");
    } finally {
      setProductionLoader(false);
      productionSaveLock.current = false;
    }
  };

  const handleOverSaveProduction = async () => {
    // Prevent duplicate API calls
    if (productionSaveLock.current) return;
    const qty = Number(productionQty);

    // if (!qty || qty <= 0) {
    //   show("Please enter a valid production quantity.");
    //   return;
    // }

    let endpoint;
    let apiData;

    switch (activeType) {
      case "Order Wise":
        endpoint = "production/updateVoucherProduction";

        apiData = {
          managerId,
          voucherId: selectedItem.orderId,
          productionQty: qty,
        };
        break;

      case "Item Wise":
        endpoint = "production/updateOverProduceQty";

        apiData = {
          managerId,
          voucherId: selectedItem.orderId,
          itemId: selectedItem.itemId,
          producedQty: qty,
          productionLine: machine,
        };
        break;

      case "Production Line Wise":
        endpoint = "production/updateOverProduceQty";

        apiData = {
          managerId,
          voucherId: selectedItem.orderId,
          itemId: selectedItem.itemId,
          producedQty: qty,
          productionLine: machine,
        };
        break;

      default:
        show("Invalid production type.");
        return;
    }

    // Lock immediately, before starting the request
    productionSaveLock.current = true;

    try {
      setProductionLoader(true);
      // console.log("endpoint", endpoint, apiData);

      const result = await fetchData(endpoint, apiData);

      if (result?.status === "success") {
        show(result?.msg || "Production updated successfully.", "success");

        setIsUpdateModalOpen(false);
        setReFetch((prev) => !prev);
      } else {
        show(result?.msg || "Failed to update production.", "error");
      }
    } catch (error) {
      console.error("Production save error:", error);

      show("Failed to update production.", "error");
    } finally {
      setProductionLoader(false);
      productionSaveLock.current = false;
    }
  };

  const handleQueueEdit = async (item) => {
    // console.log(item);

    setQueueEditItem(item);

    let endpoint;
    let payload;

    switch (activeType) {
      case "Order Wise":
        endpoint = "production/getMaxVoucherQueue";

        payload = {
          managerId,
          voucherId: item?.orderId || item?.voucherNo,
        };
        break;

      case "Item Wise":
        endpoint = "production/getMaxItemQueue";

        payload = {
          managerId,
          voucherId: item?.orderId || item?.voucherNo,
        };
        break;

      case "Production Line Wise":
        endpoint = "production/getMaxItemQueue";

        payload = {
          managerId,
          voucherId: item?.orderId || item?.voucherNo,
        };
        break;

      default:
        show("Invalid production type.", "error");
        return;
    }

    try {
      setQueueMaxLoader(true);

      // console.log("Queue API:", endpoint);
      // console.log("Queue Payload:", payload);

      const result = await fetchData(endpoint, payload);

      if (result?.status === "success") {
        setMaxQueue(result?.msg);
      } else {
        show(result?.msg || "Failed to get maxQueue", "error");
        setMaxQueue(0);
      }
    } catch (error) {
      console.error("Get max queue error:", error);
      setMaxQueue(0);
      show("Failed to get maxQueue", "error");
    } finally {
      setQueueMaxLoader(false);
    }
  };

  const renderCell = (col, item) => {
    switch (col.key) {
      case "createdAt":
        return (
          <div className={styles.entry} style={{ fontSize: 11 }}>
            <div style={{ fontWeight: 600, color: mode ? "#fff" : "#000000" }}>
              {item.voucherNo}
            </div>
            <div style={{ color: mode ? "#ffffff" : "#000000", marginTop: 1 }}>
              {formatDateTime(item.createdAt)}
            </div>
          </div>
        );
      case "voucherNo_Date":
        return (
          <div className={styles.entry} style={{ fontSize: 11 }}>
            <div
              title={item.voucherNo}
              style={{ fontWeight: 600, color: mode ? "#fff" : "#000000" }}
            >
              {item.voucherNo}
            </div>
            <div
              title={formatDateTime(item.createdAt)}
              style={{ color: mode ? "#ffffff" : "#000000", marginTop: 1 }}
            >
              {formatDateTime(item.createdAt)}
            </div>
          </div>
        );
      case "orderId_date":
        return (
          <div className={styles.entry} style={{ fontSize: 11 }}>
            <div
              title={item.orderId}
              style={{ fontWeight: 600, color: mode ? "#fff" : "#000000" }}
            >
              {item.orderId}
            </div>
            <div
              title={formatDateTime(item.createdAt)}
              style={{ color: mode ? "#ffffff" : "#000000", marginTop: 1 }}
            >
              {formatDateTime(item.createdAt)}
            </div>
          </div>
        );

      case "warehouse":
        return (
          <div
            className={styles.entry}
            style={{ fontSize: 11, fontWeight: 400 }}
          >
            {item.warehouse}
          </div>
        );
      case "updatedAt":
        return (
          <div className={styles.entry} title={item.updatedAt}>
            <LastActionCell lastAction={item.updatedAt} />
          </div>
        );
      case "totalItems":
        return (
          <div
            className={styles.entry}
            style={{ fontWeight: 600, fontSize: 13 }}
          >
            {item.totalItems}
          </div>
        );
      case "pendingItems":
        return (
          <div
            className={styles.entry}
            style={{
              fontWeight: 600,
              color: item.pendingItems > 0 ? "#F04438" : "#12B76A",
            }}
          >
            {item.pendingItems}
          </div>
        );
      case "totalQty":
        return (
          <div className={styles.entry}>
            {item.totalQty ?? item.requiredQty ?? "-"}
          </div>
        );
      case "pendingQty":
        return (
          <div
            className={styles.entry}
            style={{
              color: item.pendingQty > 0 ? "#F04438" : "#12B76A",
              fontWeight: 600,
            }}
          >
            {item.pendingQty}
          </div>
        );
      case "requiredQty":
        return <div className={styles.entry}>{item.requiredQty}</div>;
      case "producedQty":
        return (
          <div
            className={styles.entry}
            style={{ color: "#12B76A", fontWeight: 600 }}
          >
            {item.producedQty}
          </div>
        );
      case "progress":
        return (
          <div style={{ width: "100%", paddingRight: 4 }}>
            <ProgressBar
              produced={item.producedQty}
              required={item.requiredQty || item.totalQty || 1}
              mode={mode}
            />
          </div>
        );
      case "status":
        return <StatusBadge status={item.status} mode={mode} />;
      case "priority":
        return (
          <div
            className={styles.urgentBadge}
            style={{
              backgroundColor:
                item.priority === "Normal" ? "#4164E3" : "#f04438",
            }}
          >
            {item.priority}
          </div>
        );
      case "machine":
        return (
          <div className={styles.entry} style={{ fontSize: 12 }}>
            {item.machine ?? "-"}
          </div>
        );
      case "itemCode":
        return <div className={styles.entry}>{item.itemCode ?? "-"}</div>;
      case "collection":
        return <div className={styles.entry}>{item.collection ?? "-"}</div>;
      case "customer":
        return (
          <div className={styles.entry} style={{ fontSize: 12 }}>
            {item.customer ?? "-"}
          </div>
        );
      // case "action":
      //   return (
      //     <ThreeDotMenu
      //       activeType={activeType}
      //       item={item}
      //       mode={mode}
      //       onUpdate={openUpdateModal}
      //       // onUpdate={(it) => openUpdateModal(it)}
      //       onQueueEdit={(it) => setQueueEditItem(it)}
      //       onPriorityEdit={(it) => setPriorityEditItem(it)}
      //       onCancel={(it) => openCancelOrderModal(it)}
      //     />
      //   );
      case "action":
        return (
          <div>
            {(!item?.machine?.trim() ||
              machines.some(
                (machine) =>
                  machine?.label?.trim().toLowerCase() ===
                  item?.machine?.trim().toLowerCase(),
              )) && (
              <ThreeDotMenu
                activeType={activeType}
                item={item}
                mode={mode}
                onUpdate={openUpdateModal}
                onRelease={(it) => setReleaseLineItem(it)}
                onQueueEdit={handleQueueEdit}
                onPriorityEdit={(it) => setPriorityEditItem(it)}
                onCancel={(it) => openCancelOrderModal(it)}
                managerAuth={managerAuth}
                isSuperAdmin={isSuperAdmin}
              />
            )}
          </div>
        );
      default:
        return <div className={styles.entry}>{item[col.key] ?? "-"}</div>;
    }
  };

  const currentItem = selectedItem
    ? productionTableData[activeType]?.find((r) => r.id === selectedItem.id) ||
      selectedItem
    : null;

  const handlePriorityUpdate = async (item) => {
    // console.log("Priority Update:", item);
    const newPriority = item?.priority === "Normal" ? "Urgent" : "Normal";

    const apiData = {
      managerId,
      voucherId: item?.orderId,
      priority: newPriority,
    };

    try {
      setPriorityLoader(true);

      const result = await fetchData(
        "production/updateVoucherPriority",
        apiData,
      );

      // console.log("Priority update result:", result);

      if (result?.status === "success") {
        show(result?.msg || "Priority updated successfully.", "success");

        setPriorityEditItem(null);
        setReFetch((prev) => !prev);
      } else {
        show(result?.msg || "Failed to update priority.", "error");
      }
    } catch (error) {
      console.error("Priority update error:", error);
      show("Failed to update priority.", "error");
    } finally {
      setPriorityLoader(false);
    }
  };

  const handleReleaseLine = async (item) => {
    const apiData = {
      managerId,
      voucherId: item?.orderId,
      itemId: item?.itemId,
    };

    try {
      setReleaseLoader(true);

      const result = await fetchData(
        "production/releaseProductionItem",
        apiData,
      );

      // console.log("Priority update result:", result);

      if (result?.status === "success") {
        show(result?.msg || "Line Released successfully.", "success");

        setReleaseLineItem(null);
        setReFetch((prev) => !prev);
      } else {
        show(result?.msg || "Failed to Line Release.", "error");
      }
    } catch (error) {
      console.error("Line Release error:", error);
      show("Failed to Line Release.", "error");
    } finally {
      setReleaseLoader(false);
    }
  };

  const openCancelOrderModal = (item) => {
    setCancelItem(item);
  };

  // const handleCancelOrder = async (reason) => {
  //   if (!cancelItem) return;

  //   const apiData = {
  //     managerId,
  //     voucherId: cancelItem?.orderId,
  //     cancelReason: reason,
  //   };

  //   try {
  //     setCancelLoader(true);

  //     const result = await fetchData(
  //       "production/cancelProductionVoucher",
  //       apiData,
  //     );

  //     if (result?.status === "success") {
  //       show(result?.msg || "Voucher cancelled successfully.", "success");
  //       setCancelItem(null);
  //       setReFetch((prev) => !prev);
  //     } else {
  //       show(result?.msg || "Failed to cancel voucher.", "error");
  //     }
  //   } catch (error) {
  //     console.error("Voucher cancel error:", error);
  //     show("Failed to cancel voucher.", "error");
  //   } finally {
  //     setCancelLoader(false);
  //   }
  // };

  const handleCancelOrder = async (reason) => {
    if (!cancelItem) return;

    let endpoint;
    let apiData;

    switch (activeType) {
      case "Order Wise":
        endpoint = "production/cancelProductionVoucher";

        apiData = {
          managerId,
          voucherId: cancelItem?.orderId,
          cancelReason: reason,
        };
        break;

      case "Item Wise":
      case "Production Line Wise":
        endpoint = "production/cancelProductionItem";

        apiData = {
          managerId,
          voucherId: cancelItem?.orderId,
          itemId: cancelItem?.itemId || cancelItem?.id,
          // cancelReason: reason,
        };
        break;

      default:
        return;
    }

    try {
      setCancelLoader(true);

      const result = await fetchData(endpoint, apiData);

      if (result?.status === "success") {
        show(
          result?.msg ||
            (activeType === "Order Wise"
              ? "Voucher cancelled successfully."
              : "Item cancelled successfully."),
          "success",
        );

        setCancelItem(null);
        setReFetch((prev) => !prev);
      } else {
        show(
          result?.msg ||
            (activeType === "Order Wise"
              ? "Failed to cancel voucher."
              : "Failed to cancel item."),
          "error",
        );
      }
    } catch (error) {
      console.error("Cancel production error:", error);

      show(
        activeType === "Order Wise"
          ? "Failed to cancel voucher."
          : "Failed to cancel item.",
        "error",
      );
    } finally {
      setCancelLoader(false);
    }
  };
  return (
    <div
      className={styles.production}
      style={mode ? { backgroundColor: "#2C2E33", border: "none" } : {}}
    >
      {cancelItem && (
        <ModalWrapper
          isOpen={!!cancelItem}
          onClose={cancelLoader ? undefined : () => setCancelItem(null)}
        >
          {/* <CancelReasonModal
            onClose={() => setCancelItem(null)}
            onSubmit={handleCancelOrder}
            mode={mode}
            type="voucher"
            heading="Cancel Voucher"
            subHeading={`Are you sure you want to cancel ${cancelItem?.orderId}?`}
            loading={cancelLoader}
          /> */}

          <CancelReasonModal
            onClose={() => setCancelItem(null)}
            onSubmit={handleCancelOrder}
            mode={mode}
            type={
              activeType === "Item Wise" ||
              activeType === "Production Line Wise"
                ? "Voucher Item"
                : "voucher"
            }
            heading={
              activeType === "Item Wise" ||
              activeType === "Production Line Wise"
                ? "Cancel Voucher Item"
                : "Cancel Voucher"
            }
            subHeading={`Are you sure you want to cancel ${
              activeType === "Item Wise" ||
              activeType === "Production Line Wise"
                ? `${cancelItem?.orderId || ""} - ${cancelItem?.itemCode || ""} `
                : cancelItem?.orderId
            }?`}
            loading={cancelLoader}
            activeType={activeType}
          />
        </ModalWrapper>
      )}

      {queueEditItem && (
        <QueueEditModal
          item={queueEditItem}
          maxQueue={maxQueue}
          mode={mode}
          queueloader={queueloader}
          queueMaxLoader={queueMaxLoader}
          onConfirm={(n) =>
            handleQueueUpdate(queueEditItem.orderId, n, queueEditItem?.itemId)
          }
          onClose={() => {
            setQueueEditItem(null);
            setMaxQueue(0);
          }}
          activeType={activeType}
        />
      )}

      {priorityEditItem && (
        <PriorityEditModal
          item={priorityEditItem}
          mode={mode}
          activeType={activeType}
          priorityLoader={priorityLoader}
          onConfirm={handlePriorityUpdate}
          onClose={() => setPriorityEditItem(null)}
        />
      )}

      {releaseLineItem && (
        <ReleaseLineModal
          item={releaseLineItem}
          mode={mode}
          activeType={activeType}
          releaseLoader={releaseLoader}
          onConfirm={handleReleaseLine}
          onClose={() => setReleaseLineItem(null)}
        />
      )}

      {/* ── TOP BAR ── */}
      <div className={styles.production_top}>
        <div className={styles.production_top_left}>
          <TopTabBar text={"Production"} />
        </div>
        <div className={styles.production_right}>
          <div>
            <SlidingFilter2
              itemList={daysData.map((item) => item.label)}
              setFilter={handleDayChange}
              selectedItem={
                daysData.find((item) => item.value === filter.orderdDaysTab)
                  ?.label
              }
            />
          </div>

          {filter.orderdDaysTab === "period" && (
            <>
              <div className={styles.period}>
                <InputTypedate
                  text={"From"}
                  value={filter.orderStartDate}
                  max={filter.orderEndDate}
                  onChange={(e) => {
                    production(setFilter({ orderStartDate: e.target.value }));
                    production(setFilter({ selectedFilter: "" }));
                  }}
                />
              </div>
              {filter.orderStartDate !== "" && (
                <div className={styles.period}>
                  <InputTypedate
                    text={"To"}
                    value={filter.orderEndDate}
                    min={filter.orderStartDate}
                    onChange={(e) => {
                      production(setFilter({ orderEndDate: e.target.value }));
                      production(setFilter({ selectedFilter: "" }));
                    }}
                  />
                </div>
              )}
            </>
          )}

          {isSuperAdmin && (
            <div className={styles.financialYear}>
              <DropDown
                label={"F.Y."}
                listLabel={"2025-2026"}
                options={yearData}
                onSelect={(option) =>
                  production(setFilter({ selectedYear: option.label }))
                }
                onReject={() => production(setFilter({ selectedYear: null }))}
              />
            </div>
          )}

          <div className={styles.reload}>
            <Button
              buttonIcon={<DispatchReloadIcon />}
              buttonBgColor={"#000000"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={resetAllStates}
            />
          </div>
          <div>
            <Button
              buttonIcon={<CreateVoucherIcon />}
              buttonText={"Manage Production"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={() => navigate("/production/manageProduction")}
            />
          </div>
          <div className={styles.pegination}>
            <Pagination2
              mode={mode}
              currentPage={pagination.page}
              setCurrentPage={(newPage) =>
                production(setPagination({ page: newPage }))
              }
              totalPages={pagination.pages}
            />
          </div>
        </div>
      </div>

      {/* ── STATUS CARDS ── */}
      <div>
        <div
          className={styles.production_filters}
          style={
            mode ? { borderColor: "#232529", backgroundColor: "#232529" } : {}
          }
        >
          <ProductionFilters
            mode={mode}
            headerData={statusCards}
            selectedFilter={filter.selectedFilter}
            handleClick={(s) => {
              production(setFilter({ selectedFilter: s }));
              production(setPagination({ page: 1 }));
            }}
            type={"Production & Sale"}
            getData={getAllProductionData}
          />
        </div>
      </div>

      {/* ── DATA SECTION ── */}
      <div className={styles.production_data}>
        <div className={styles.production_data_filters}>
          <div>
            <SearchBar
              placeholder={"Search"}
              value={filter.keyword}
              onChange={(e) => {
                production(setFilter({ keyword: e.target.value }));
              }}
              onClear={(e) => {
                production(setFilter({ keyword: "" }));
              }}
            />
          </div>
          <div>
            <SlidingFilter2
              itemList={productionTypeData}
              setFilter={handleVoucherChange}
              selectedItem={activeType}
            />
            {isSuperAdmin && (
              <DropDown
                label={"Warehouse"}
                listLabel={"All"}
                options={warehouses}
                onSelect={(option) =>
                  production(setFilter({ selectedWarehouseId: option.value }))
                }
                onReject={() =>
                  production(setFilter({ selectedWarehouseId: null }))
                }
              />
            )}

            {activeType === "Production Line Wise" && (
              <DropDown
                label={"Production Line"}
                listLabel={"All"}
                options={machines}
                onSelect={(option) => {
                  setSelectedMachine(option.value);
                }}
                onReject={() => {
                  setSelectedMachine("");
                }}
              />
            )}
          </div>
        </div>

        {/* ── TABLE ── */}
        <div ref={tableRef} className={styles.production_table_wrapper}>
          <ul className={styles.production_data_list}>
            {/* Header */}
            <li
              className={`${styles.production_data_list_row_header} ${mode ? styles.production_data_list_row_header_dark : ""}`}
              style={{ gridTemplateColumns: gridTemplate }}
            >
              <div title="Queue">Queue</div>
              {columns.map((col) => (
                <div key={col.key} title={col.label}>
                  {col.label}
                </div>
              ))}
            </li>

            {loading ? (
              <TableSkeleton
                gridTemplate={gridTemplate}
                columns={columns}
                rows={limit}
                mode={mode}
              />
            ) : (
              <>
                {pagedData.map((item) => {
                  const isItemOrProductionLine =
                    activeType === "Item Wise" ||
                    activeType === "Production Line Wise";

                  const hasValue = (value) =>
                    value !== undefined && value !== null && value !== "";

                  const queueValue = isItemOrProductionLine
                    ? hasValue(item.voucherQueue) && hasValue(item.queueNo)
                      ? `${item.voucherQueue}/${item.queueNo}`
                      : hasValue(item.voucherQueue)
                        ? item.voucherQueue
                        : hasValue(item.queueNo)
                          ? item.queueNo
                          : ""
                    : hasValue(item.queueNo)
                      ? item.queueNo
                      : "";

                  return (
                    <li
                      key={item.id}
                      className={`${styles.production_data_list_row} ${mode ? styles.production_data_list_row_dark : ""}`}
                      style={{
                        gridTemplateColumns: gridTemplate,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (
                          activeType === "Item Wise" ||
                          activeType === "Production Line Wise"
                        )
                          return;
                        navigate(
                          `/production/productionDetails/${item.orderId || item.id}`,
                          {
                            state: {
                              tabType:
                                activeType === "Production Line Wise"
                                  ? "Machine Wise"
                                  : "Order Wise",
                              status: item?.status,
                            },
                          },
                        );
                      }}
                    >
                      <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                      >
                        {/* <div className={styles.entry} title={item.queueNo}>
                        {item.queueNo}
                      </div> */}

                        <div className={styles.entry} title={queueValue}>
                          {queueValue}
                        </div>
                      </div>
                      {columns.map((col) => (
                        <div
                          key={col.key}
                          title={String(item[col.key] ?? "")}
                          className={styles.tableCell}
                          onClick={
                            col.key === "action"
                              ? (e) => e.stopPropagation()
                              : undefined
                          }
                        >
                          {renderCell(col, item)}
                        </div>
                      ))}
                    </li>
                  );
                })}

                {pagedData.length === 0 && (
                  <div className={styles.no_data}>
                    <NoDataFound
                      icon={<TemplateNotFound />}
                      textTitle={"No Data Found"}
                    />
                  </div>
                )}
              </>
            )}
          </ul>
        </div>

        <div className={styles.mobileCards}>
          {loading
            ? Array.from({ length: limit }).map((_, i) => (
                <div
                  key={i}
                  className={`${styles.mobileCard} ${mode ? styles.mobileCardDark : ""} ${styles.skeletonCard}`}
                >
                  <div
                    className={styles.skeletonBlock}
                    style={{ height: 16, width: "60%" }}
                  />
                  <div
                    className={styles.skeletonBlock}
                    style={{ height: 12, marginTop: 10 }}
                  />
                  <div
                    className={styles.skeletonBlock}
                    style={{ height: 12, marginTop: 8 }}
                  />
                </div>
              ))
            : pagedData.map((item) => (
                <MobileProductionCard
                  key={item.id}
                  item={item}
                  mode={mode}
                  onUpdate={(selectedItem) => {
                    setMobileProdItem(selectedItem);
                    setMachine(selectedItem.pLId || "");
                    setIsUpdateModalOpen(true);
                  }}
                />
              ))}
        </div>

        {/* ── UPDATE DRAWER ── */}

        {isUpdateModalOpen && currentItem && (
          <UpdateProductionDrawer
            open={isUpdateModalOpen}
            currentItem={currentItem}
            mode={mode}
            productionQty={productionQty}
            setProductionQty={setProductionQty}
            machine={machine}
            machineOptions={machines}
            setMachine={setMachine}
            status={status}
            setStatus={setStatus}
            addQty={addQty}
            completeProduction={completeProduction}
            handleSaveProduction={handleSaveProduction}
            productionLoader={productionLoader}
            onClose={() => setIsUpdateModalOpen(false)}
            activeType={activeType}
            productionSaveLock={productionSaveLock}
            handleOverSaveProduction={handleOverSaveProduction}
          />
        )}
      </div>
    </div>
  );
};

export default Production;
